import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Store, StoresService } from 'src/app/core/stores.service';
import { DialogService } from 'src/app/core/dialog.service';
import { StoresTicketDialogComponent } from 'src/app/stores/stores-ticket-dialog/stores-ticket-dialog.component';
import { StoresPaymentMethodsDialogComponent } from 'src/app/stores/stores-payment-methods-dialog/stores-payment-methods-dialog.component';
import { StoresAllowedStepsDialogComponent } from 'src/app/stores/stores-allowed-steps-dialog/stores-allowed-steps-dialog.component';
import { StoresQrCodeDialogComponent } from 'src/app/stores/stores-qr-code-dialog/stores-qr-code-dialog.component';
import { StoresPluginCredentialsDialogComponent } from 'src/app/stores/stores-plugin-credentials-dialog/stores-plugin-credentials-dialog.component';
import { StoresToggleDialogComponent } from 'src/app/stores/stores-toggle-dialog/stores-toggle-dialog.component';

@Component({
  selector: 'app-store-details-header',
  templateUrl: './store-details-header.component.html',
  styleUrls: ['./store-details-header.component.scss'],
})
export class StoreDetailsHeaderComponent {
  @Input() company_id?: string | null;
  @Input() store_id?: string | null;

  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() tab_change: EventEmitter<string> = new EventEmitter<string>();

  store?: Store;
  is_read_running = false;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private stores_service: StoresService,
    private error_service: ErrorService,
    private dialog_service: DialogService,
  ) {}

  ngOnInit(): void {
    this.readStore(this.store_id as string);
  }

  onBackClick(): void {
    this.navigation_service.toStores();
  }

  readStore(store_id: string): void {
    this.is_read_running = true;
    this.stores_service.readStore(store_id).subscribe({
      next: response => {
        this.store = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  getShrinkedID(): string {
    return this.utils_service.getShrinkedID(this.store_id || '-');
  }

  onTicketClick(): void {
    this.dialog_service
      .openDialog(StoresTicketDialogComponent, { store: this.store })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
  onEnableDisableClick(): void {
    this.dialog_service
      .openDialog(StoresToggleDialogComponent, { store: this.store })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onStoreQineticPsClick(): void {
    if (this.store) {
      this.dialog_service.openDialog(StoresPaymentMethodsDialogComponent, {
        store_id: this.store.store_id,
        company_id: this.store.company_id,
      });
    }
  }

  onAllowedStepsClick(): void {
    this.dialog_service.openDialog(StoresAllowedStepsDialogComponent, { store: this.store });
  }

  onQrCodeClick(): void {
    this.dialog_service.openDialog(StoresQrCodeDialogComponent, {
      store: this.store,
    });
  }

  onPluginCredentialsClick(): void {
    this.dialog_service
      .openDialog(StoresPluginCredentialsDialogComponent, {
        store: this.store,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
}
